import React, { memo } from 'react'

// Libraries
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { PropTypes } from "prop-types";

// components
import SocialIcons from '../SocialIcon/SocialIcons'
import FooterMenu, { Footer } from './Footer';

// Data
import FooterData from './FooterData';
import { AHS_CONTACT } from '../../Data/AHSContent';

const iconData = [
    {
        color: "#828282",
        link: "https://www.facebook.com/",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#828282",
        link: "https://twitter.com/",
        icon: "fab fa-twitter"
    },
    {
        color: "#828282",
        link: "https://www.instagram.com/",
        icon: "fab fa-instagram"
    },
]

const FooterStyle02 = ({
    data = FooterData,
    logo = "/assets/img/png/AHS Logo Final.png",
    className,
    theme,
    ...props
}) => {
    return (
        <Footer theme={theme} className={`${className ? ` ${className}` : ""}`}>
            <div className="py-[5%] lg:py-[8%] md:pb-0 xs:py-[8%]">
                <Container>
                    <Row className="md:text-start justify-start">
                        <Col lg={{ span: 3, order: 0 }} md={5} sm={{ span: 6, order: 1 }} className="md:mb-[50px] xs:mb-[25px]">
                            <Link aria-label="link" to="/" className="mb-[20px] block">
                                <img alt="logo" src={logo} width="111" height="36" />
                            </Link>
                            <p className="w-[80%] mb-[20px] xs:w-full">Your one stop destination for facility management, security and domestic services in Kolkata.</p>
                            <SocialIcons theme="social-icon-style-01" className="justify-start" size="xs" iconColor={theme === "dark" ? "light" : "dark"} data={iconData} />
                        </Col>
                        <FooterMenu className="xl:px-[15px] md:mb-[40px] xs:mb-[25px]" data={FooterData.slice(0, 3)} lg={{ span: 2, order: 0 }} sm={{ span: 4, order: 3 }} titleClass="capitalize" />
                        <Col lg={{ span: 3, order: 0 }} md={5} sm={{ span: 6, order: 2 }}>
                            <span className="font-serif font-medium block text-themecolor mb-[30px] md:mb-[15px]">Get in touch</span>
                            <p className="w-[85%] mb-[15px]">{AHS_CONTACT.address}</p>
                            <div className="mb-[10px]"><i className="feather-phone-call text-sm mr-[10px] text-themecolor"></i>{AHS_CONTACT.phone}</div>
                            <div><i className="feather-mail text-sm mr-[10px] text-themecolor"></i><a aria-label="mail" href={`mailTo:${AHS_CONTACT.email}`} className="hover:text-white">{AHS_CONTACT.email}</a></div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="footer-bottom py-[35px] border-t border-[#ffffff1a]">
                <Container>
                    <Row>
                        <Col md={6} className="md:mb-[0.75rem] xs:mb-[15px]">
                            <ul className="flex sm:justify-center md:justify-start xs:flex-col">
                                <li className="mr-[35px] md:mr-[20px] xl:mb-0 xs:mb-[7px]"><Link aria-label="link" to="#">Privacy policy</Link></li>
                                <li className="mr-[35px] md:mr-[20px] xl:mb-0 xs:mb-[7px]"><Link aria-label="link" to="#">Legal notice</Link></li>
                                <li className="xl:mb-0"><Link aria-label="link" to="#">Terms of service</Link></li>
                            </ul>
                        </Col>
                        <Col md={6} className="text-right sm:text-center xs:text-left">
                            <span className="inline-block">&copy; {new Date().getFullYear()} MindWeave is Proudly Powered by <a aria-label="themezaa" rel="noreferrer" href="https://mindweaveai.in/" target="_blank" className="text-themecolor underline underline-offset-4"> MindWeave AI Consultant</a></span>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Footer>
    )
}

FooterStyle02.propTypes = {
    className: PropTypes.string,
    logo: PropTypes.string,
}

export default memo(FooterStyle02)